import { render, staticRenderFns } from "./BannerStatsComponent.vue?vue&type=template&id=66548b58&scoped=true"
import script from "./BannerStatsComponent.vue?vue&type=script&lang=js"
export * from "./BannerStatsComponent.vue?vue&type=script&lang=js"
import style0 from "./BannerStatsComponent.vue?vue&type=style&index=0&id=66548b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66548b58",
  null
  
)

export default component.exports